import React, { useEffect, useState, useRef, useCallback } from "react";
import clsx from "clsx";
import _ from "underscore";
import { useSearchParams, useNavigate } from "react-router-dom";
import "react-day-picker/style.css";
import { DayPicker } from "react-day-picker";
import { ptBR, enUS } from "react-day-picker/locale";
import { toast } from "react-toastify";

import styles from "./education.module.css";
import { educationInstitution, getSavedEducationFilterById } from "../../../services/education";
import { useInstitution } from "../../../context/InstitutionContext";
import { useMantenedora, VIEW_MODES } from "../../../context/MantenedoraContext";
import { insightsFilters } from "../../../services/insights";

import {
  pluralize,
  formatDate,
  addPorcentage,
} from "../../../utils/formatter";
import useOutsideAlerter from "../../../utils/clickOutside";

import Button from "../../../components/button/button";
import ZeroData from "../../../components/zeroData/zeroData";
import TeacherTable from "../../../components/education/teacherTable/teacherTable";
import StudentsTreemap from "../../../components/education/studentsTreemap/studentsTreemap";
import StudentsTable, { STATUS_FILTER } from "../../../components/education/studentsTable/studentsTable";
import TreemapDrillTable from "../../../components/education/treemapDrillTable/treemapDrillTable";
import HeaderTitle from "../../../components/header/headerTitle/headerTitle";
import AcademicIcon from "../../../assets/icons/academic-icon.svg";

import FinanceCard from "../../../components/finance/financeCard/financeCard";

import CalendarIcon from "../../../assets/icons/calendar.svg";
import BarsFilterIcon from "../../../assets/icons/bars-filter.svg";
import RegistrationConcluseIcon from "../../../assets/icons/registration-concluse.svg";

import ChartMixedUpCircleDollarIcon from "../../../assets/icons/chart-mixed-up-circle-dollar.svg";

import ChartUserCheckIcon from "../../../assets/icons/chart-user-check.svg";
import ChartUserSearchIcon from "../../../assets/icons/chart-user-search.svg";
import MagnifyingGlassIcon from "../../../assets/icons/magnifying-glass-blue.svg";

// users.svg tem fill branco (some no card claro); users-two.svg e a mesma arte em azul
import UsersIcon from "../../../assets/icons/users-two.svg";
import UserDeleteIcon from "../../../assets/icons/user-delete.svg";

import DocumentCheckedFilled from "../../../assets/icons/document-checked-filled.svg";
import ChartMixedRightCircleDollar from "../../../assets/icons/chart-mixed-right-circle-dollar.svg";
import EducationDebtsPeriod from "../../../components/education/educationDebtsPeriod/educationDebtsPeriod";

import BookIcon from '../../../assets/icons/book.svg';
import DiscIcon from '../../../assets/icons/discipline.svg';
import CourseIcon from '../../../assets/icons/course.svg';
import LocaleIcon from '../../../assets/icons/locale.svg';
import ClassesIcon from '../../../assets/icons/classes.svg';
import FilterSelect from "../../../components/predictive/filterSelect/filterSelect";
import SavedFiltersModal from "../../../components/filters/savedFiltersModal/savedFiltersModal";
import SaveFilterModal from "../../../components/filters/saveFilterModal/saveFilterModal";
// ponytail: reaproveita o CSS de modal já existente em vez de criar outro module.css.
import modalStyles from "../../../components/filters/saveFilterModal/saveFilterModal.module.css";
import loadingGif from "../../../assets/loading.gif";
import { getSharedFilters, saveSharedFilters, clearSharedFilters, getDateRange, saveDateRange } from "../../../utils/localStorage";

const Education = () => {
  const { institution } = useInstitution();
  const { 
    viewMode, 
    selectedInstitutionId, 
    institutions, 
    isConsolidatedView
  } = useMantenedora();
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const calendarRef = useRef(null);

  // Determinar qual institution ID usar para as queries
  const getEffectiveInstitutionId = useCallback(() => {
    if (isConsolidatedView) return null;
    if (selectedInstitutionId) return selectedInstitutionId;
    return institution?.id;
  }, [isConsolidatedView, selectedInstitutionId, institution?.id]);

  const [initialLoadComplete, setInitialLoadComplete] = useState(false);

  // Bloco de treemap selecionado → carrega a tabela filtrada abaixo dos treemaps.
  const [drill, setDrill] = useState(null);

  // Status selecionado no treemap "Alunos por Status" / no select da tabela.
  const [studentStatus, setStudentStatus] = useState("ativo");
  const [showNoStatusModal, setShowNoStatusModal] = useState(false);

  const [showSavedFiltersModal, setShowSavedFiltersModal] = useState(false);
  const [showSaveFilterModal, setShowSaveFilterModal] = useState(false);
  const [knowledgeAreas, setKnowledgeAreas] = useState([]);
  const [selectedKnowledgeArea, setSelectedKnowledgeArea] = useState("");
  const [knowledgeAreasLoading, setKnowledgeAreasLoading] = useState(false);
  const [knowledgeAreasFetched, setKnowledgeAreasFetched] = useState(false);

  const [disciplines, setDisciplines] = useState([]);
  const [selectedDiscipline, setSelectedDiscipline] = useState("");
  const [disciplinesLoading, setDisciplinesLoading] = useState(false);
  const [disciplinesFetched, setdisciplinesFetched] = useState(false);

  const [courseTypes, setCourseTypes] = useState([]);
  const [selectedCourseType, setSelectedCourseType] = useState("");
  const [courseTypesLoading, setCourseTypesLoading] = useState(false);
  const [courseTypesFetched, setcourseTypesFetched] = useState(false);

  const [courseGrades, setCourseGrades] = useState([]);
  const [selectedCourseGrade, setSelectedCourseGrade] = useState("");
  const [courseGradesLoading, setCourseGradesLoading] = useState(false);
  const [courseGradesFetched, setcourseGradesFetched] = useState(false);

  const [localities, setLocalities] = useState([]);
  const [selectedLocality, setSelectedLocality] = useState("");
  const [localitiesLoading, setLocalitiesLoading] = useState(false);
  const [localitiesFetched, setlocalitiesFetched] = useState(false);

  const [modalities, setModalities] = useState([]);
  const [selectedModality, setSelectedModality] = useState("");
  const [modalitiesLoading, setModalitiesLoading] = useState(false);
  const [modalitiesFetched, setModalitiesFetched] = useState(false);


  const [education, setEducation] = useState(null);
  const [ageGroup, setAgeGroup] = useState({});
  const [loading, setLoading] = useState(true);
  const [suggestionRange, setSuggestionRange] = useState("");
  const [dateRangeString, setDateRangeString] = useState("");
  const [dateRange, setDateRange] = useState(() => {
    return getDateRange() || { from: new Date(new Date().getFullYear(), 0, 1), to: new Date() };
  });


  const [isCalendarOpen, setIsCalendarOpen] = useState(false);

  useOutsideAlerter(calendarRef, () => setIsCalendarOpen(false));

  // Persistir data no localStorage para compartilhar entre telas
  useEffect(() => {
    if (dateRange?.from && dateRange?.to) {
      saveDateRange(dateRange);
    }
  }, [dateRange]);

  useEffect(() => {
    // Só buscar dados iniciais se não houver filterId na URL
    const urlFilterId = searchParams.get('filterId');
    
    if (!urlFilterId && initialLoadComplete) {
      fetchInstitutionEducation({
        startDate: formatDate(dateRange?.from).replaceAll("/", "-"),
        endDate: formatDate(dateRange?.to).replaceAll("/", "-"),
        filtermodality: selectedModality
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialLoadComplete]);

  // Refazer fetch quando a instituição selecionada ou modo de visualização muda
  useEffect(() => {
    if (initialLoadComplete) {
      fetchInstitutionEducation({
        startDate: formatDate(dateRange?.from).replaceAll("/", "-"),
        endDate: formatDate(dateRange?.to).replaceAll("/", "-"),
        knowledgeArea: selectedKnowledgeArea,
        discipline: selectedDiscipline,
        courseTypeId: selectedCourseType,
        courseGradeId: selectedCourseGrade,
        localityId: selectedLocality,
        filtermodality: selectedModality
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewMode, selectedInstitutionId]);

  useEffect(() => {
    setDateRangeString(
      `${formatDate(dateRange?.from)} - ${formatDate(dateRange?.to)}`
    );
  }, [dateRange]);

  // Salvar filtros no localStorage sempre que houver mudanças (incluindo data sempre)
  useEffect(() => {
    // Só salvar se já tiver feito o carregamento inicial
    if (!initialLoadComplete) return;
    
    const filtersToSave = {
      source: "Academico",
      dateRange: {
        from: dateRange?.from ? dateRange.from.toISOString() : null,
        to: dateRange?.to ? dateRange.to.toISOString() : null
      },
      filters: {
        courseType: selectedCourseType || "",
        knowledgeArea: selectedKnowledgeArea || "",
        discipline: selectedDiscipline || "",
        locality: selectedLocality || "",
        modality: selectedModality || ""
      }
    };
    saveSharedFilters(filtersToSave);
  }, [
    initialLoadComplete,
    selectedCourseType, 
    selectedKnowledgeArea, 
    selectedDiscipline, 
    selectedLocality, 
    selectedModality,
    dateRange
  ]);

  // Inicializar filtro da URL se houver filterId
  useEffect(() => {
    const urlFilterId = searchParams.get('filterId');
    
    if (urlFilterId && institution?.id && !initialLoadComplete) {
      const fetchFilterById = async () => {
        try {
          const savedFilter = await getSavedEducationFilterById({ 
            institutionId: institution.id, 
            filterId: urlFilterId 
          });
          
          console.log("Filtro carregado da URL:", savedFilter);
          
          // Parse do filterJson
          const filterData = typeof savedFilter.filterJson === 'string' 
            ? JSON.parse(savedFilter.filterJson) 
            : savedFilter.filterJson;
          
          // Preparar datas para busca
          let fetchStartDate = formatDate(dateRange.from).replaceAll("/", "-");
          let fetchEndDate = formatDate(dateRange.to).replaceAll("/", "-");
          
          // Aplicar filtros de data
          if (filterData.dateRange) {
            const newDateRange = {};
            
            if (filterData.dateRange.startDate) {
              const [day, month, year] = filterData.dateRange.startDate.split('-');
              newDateRange.from = new Date(year, month - 1, day);
              fetchStartDate = filterData.dateRange.startDate;
            }
            
            if (filterData.dateRange.endDate) {
              const [day, month, year] = filterData.dateRange.endDate.split('-');
              newDateRange.to = new Date(year, month - 1, day);
              fetchEndDate = filterData.dateRange.endDate;
            }
            
            if (newDateRange.from || newDateRange.to) {
              setDateRange(prev => ({
                from: newDateRange.from || prev.from,
                to: newDateRange.to || prev.to
              }));
            }
          }

          // Carregar opções das listas antes de aplicar os filtros
          console.log("Carregando opções das listas...");
          
          // Carregar sempre as listas básicas
          if (knowledgeAreas.length === 0) {
            await fetchKnowledgeAreas();
          }
          if (courseTypes.length === 0) {
            await fetchCourseTypes();
          }
          if (modalities.length === 0) {
            await fetchModalities();
          }
          
          // Carregar listas dependentes se houver valores nos filtros
          if (filterData.filters?.knowledgeArea && disciplines.length === 0) {
            await fetchDisciplines();
          }
          if (filterData.filters?.discipline && localities.length === 0) {
            await fetchLocalities();
          }
          
          console.log("Listas carregadas!");

          // Aplicar filtros - SEMPRE atualizar, mesmo se vazio
          if (filterData.filters) {
            console.log("Atualizando campos de filtro da URL:", filterData.filters);
            
            // Atualizar todos os campos, mesmo que vazios
            setSelectedCourseType(filterData.filters.courseType || "");
            setSelectedKnowledgeArea(filterData.filters.knowledgeArea || "");
            setSelectedDiscipline(filterData.filters.discipline || "");
            setSelectedLocality(filterData.filters.locality || "");
            setSelectedModality(filterData.filters.modality || "");
          }
          
          // Buscar dados com os filtros aplicados
          await fetchInstitutionEducation({
            startDate: fetchStartDate,
            endDate: fetchEndDate,
            knowledgeArea: filterData.filters?.knowledgeArea || "",
            discipline: filterData.filters?.discipline || "",
            courseTypeId: filterData.filters?.courseType || "",
            localityId: filterData.filters?.locality || "",
            filtermodality: filterData.filters?.modality || ""
          });
          
          toast.success(`Filtro "${savedFilter.name}" aplicado automaticamente!`);
          setInitialLoadComplete(true);
        } catch (error) {
          console.error("Erro ao buscar filtro por ID:", error);
          toast.error("Erro ao carregar filtro da URL");
          setInitialLoadComplete(true);
          setLoading(false);
        }
      };
      
      fetchFilterById();
    } else if (!urlFilterId) {
      // Verificar se há filtros salvos no localStorage
      const sharedFilters = getSharedFilters();
      
      if (sharedFilters && institution?.id) {
        
        const applySharedFilters = async () => {
          try {
            // Aplicar filtros de data
            if (sharedFilters.dateRange) {
              const newDateRange = {};
              
              if (sharedFilters.dateRange.from) {
                newDateRange.from = new Date(sharedFilters.dateRange.from);
              }
              
              if (sharedFilters.dateRange.to) {
                newDateRange.to = new Date(sharedFilters.dateRange.to);
              }
              
              if (newDateRange.from || newDateRange.to) {
                setDateRange(prev => ({
                  from: newDateRange.from || prev.from,
                  to: newDateRange.to || prev.to
                }));
              }
            }

            // Carregar opções das listas antes de aplicar os filtros
            if (sharedFilters.filters?.knowledgeArea && knowledgeAreas.length === 0) {
              await fetchKnowledgeAreas();
            }
            if (sharedFilters.filters?.courseType && courseTypes.length === 0) {
              await fetchCourseTypes();
            }
            if (sharedFilters.filters?.modality && modalities.length === 0) {
              await fetchModalities();
            }
            if (sharedFilters.filters?.discipline && disciplines.length === 0) {
              await fetchDisciplines();
            }
            if (sharedFilters.filters?.locality && localities.length === 0) {
              await fetchLocalities();
            }

            // Aplicar filtros
            if (sharedFilters.filters) {
              setSelectedCourseType(sharedFilters.filters.courseType || "");
              setSelectedKnowledgeArea(sharedFilters.filters.knowledgeArea || "");
              setSelectedDiscipline(sharedFilters.filters.discipline || "");
              setSelectedLocality(sharedFilters.filters.locality || "");
              setSelectedModality(sharedFilters.filters.modality || "");
            }

            // Buscar dados com os filtros aplicados
            const fetchStartDate = sharedFilters.dateRange?.from 
              ? formatDate(new Date(sharedFilters.dateRange.from)).replaceAll("/", "-")
              : formatDate(dateRange.from).replaceAll("/", "-");
            const fetchEndDate = sharedFilters.dateRange?.to 
              ? formatDate(new Date(sharedFilters.dateRange.to)).replaceAll("/", "-")
              : formatDate(dateRange.to).replaceAll("/", "-");

            await fetchInstitutionEducation({
              startDate: fetchStartDate,
              endDate: fetchEndDate,
              knowledgeArea: sharedFilters.filters?.knowledgeArea || "",
              discipline: sharedFilters.filters?.discipline || "",
              courseTypeId: sharedFilters.filters?.courseType || "",
              localityId: sharedFilters.filters?.locality || "",
              filtermodality: sharedFilters.filters?.modality || ""
            });


            setInitialLoadComplete(true);
          } catch (error) {
            console.error("Erro ao aplicar filtros compartilhados:", error);
            setInitialLoadComplete(true);
          }
        };

        applySharedFilters();
      } else {
        setInitialLoadComplete(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams, institution?.id, initialLoadComplete]);

  // Função para agregar dados educacionais de múltiplas instituições
  const aggregateEducationData = (dataArray) => {
    if (!dataArray || dataArray.length === 0) return null;
    if (dataArray.length === 1) return dataArray[0];

    const aggregated = JSON.parse(JSON.stringify(dataArray[0]));
    
    // Soma campos numéricos
    const sumFields = ['totalStudents', 'totalEnrollments', 'totalGraduates',
                       'totalDropouts', 'totalTeachers', 'totalClasses',
                       'totalEnrolledStudents', 'activeStudents', 'inactiveStudents'];
    
    for (let i = 1; i < dataArray.length; i++) {
      const data = dataArray[i];
      sumFields.forEach(field => {
        aggregated[field] = (aggregated[field] || 0) + (data[field] || 0);
      });
    }

    // Média para taxas e percentuais
    const avgFields = ['enrollmentRate', 'dropoutRate', 'graduationRate', 'retentionRate',
                       'ageGroup_0_18', 'ageGroup_18_25', 'ageGroup_26_35', 
                       'ageGroup_36_45', 'ageGroup_46Plus'];
    avgFields.forEach(field => {
      let total = 0;
      let count = 0;
      dataArray.forEach(data => {
        if (data[field] !== undefined) {
          total += data[field];
          count++;
        }
      });
      if (count > 0) {
        aggregated[field] = total / count;
      }
    });

    // Concatena arrays
    const arrayFields = ['courseStats', 'teacherStats', 'enrollmentsByPeriod', 'studentData'];
    arrayFields.forEach(field => {
      if (Array.isArray(aggregated[field])) {
        dataArray.slice(1).forEach(data => {
          if (Array.isArray(data?.[field])) {
            aggregated[field] = [...aggregated[field], ...data[field]];
          }
        });
      }
    });

    return aggregated;
  };

  const fetchInstitutionEducation = useCallback(
    _.debounce(async ({
      startDate,
      endDate,
      knowledgeArea,
      discipline,
      courseTypeId,
      courseGradeId,
      localityId,
      filtermodality,
    }) => {
      try {
        setLoading(true);
        
        const effectiveId = getEffectiveInstitutionId();
        
        if (isConsolidatedView && institutions.length > 0) {
          // Modo consolidado
          const promises = institutions.map(inst => 
            educationInstitution({
              institutionId: inst.id,
              startDate,
              endDate,
              knowledgeArea,
              discipline,
              courseTypeId,
              courseGradeId,
              localityId,
              filtermodality
            }).catch(err => {
              console.warn(`Erro ao buscar dados da instituição ${inst.id}:`, err);
              return null;
            })
          );
          
          const results = await Promise.all(promises);
          const validResults = results
            .filter(r => r !== null && r.educationData)
            .map(r => r.educationData);
          
          const aggregatedData = aggregateEducationData(validResults);
          setEducation(aggregatedData);
          
          if (aggregatedData) {
            const ageGroup = {
              ageGroup_0_18: Number((aggregatedData.ageGroup_0_18 || 0).toFixed(2)),
              ageGroup_18_25: Number((aggregatedData.ageGroup_18_25 || 0).toFixed(2)),
              ageGroup_26_35: Number((aggregatedData.ageGroup_26_35 || 0).toFixed(2)),
              ageGroup_36_45: Number((aggregatedData.ageGroup_36_45 || 0).toFixed(2)),
              moreThan40: Number((aggregatedData.ageGroup_46Plus || 0).toFixed(2))
            };
            setAgeGroup(ageGroup);
          }
        } else {
          // Modo individual
          const institutionId = effectiveId || institution?.id;
          if (!institutionId) {
            console.warn("Nenhuma instituição selecionada");
            setLoading(false);
            return;
          }
          
          const response = await educationInstitution({
            institutionId,
            startDate,
            endDate,
            knowledgeArea,
            discipline,
            courseTypeId,
            courseGradeId,
            localityId,
            filtermodality
          });

          setEducation(response.educationData);

          const ageGroup = {
            ageGroup_0_18: Number((response.educationData.ageGroup_0_18 || 0).toFixed(2)),
            ageGroup_18_25: Number((response.educationData.ageGroup_18_25 || 0).toFixed(2)),
            ageGroup_26_35: Number((response.educationData.ageGroup_26_35 || 0).toFixed(2)),
            ageGroup_36_45: Number((response.educationData.ageGroup_36_45 || 0).toFixed(2)),
            moreThan40: Number((response.educationData.ageGroup_46Plus || 0).toFixed(2))
          };
          setAgeGroup(ageGroup);
        }
        
        setIsCalendarOpen(false);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }, 1000),
    [getEffectiveInstitutionId, isConsolidatedView, institutions, institution?.id]
  );

  const selectManualRange = () => {
    setSuggestionRange("");

    fetchInstitutionEducation({
      startDate: formatDate(dateRange.from).replaceAll("/", "-"),
      endDate: formatDate(dateRange.to).replaceAll("/", "-"),
      knowledgeArea: selectedKnowledgeArea,
      discipline: selectedDiscipline,
      courseTypeId: selectedCourseType,
      courseGradeId: selectedCourseGrade,
      localityId: selectedLocality,
      filtermodality: selectedModality
    });
  };

  const handleKnowledgeAreaChange = (e) => {
    const newKnowledgeArea = e.target.value;

    setSelectedKnowledgeArea(newKnowledgeArea);
    setSelectedDiscipline('');
    setSelectedCourseType('');
    setSelectedCourseGrade('');
    setSelectedLocality('');
    setSelectedModality('');

    setDisciplines([]);
    setCourseTypes([]);
    setCourseGrades([]);
    setLocalities([]);
    setModalities([]);

    fetchInstitutionEducation({
      startDate: formatDate(dateRange.from).replaceAll("/", "-"),
      endDate: formatDate(dateRange.to).replaceAll("/", "-"),
      knowledgeArea: newKnowledgeArea,
      courseTypeId: selectedCourseType
    });
  };

  const handleDisciplineChange = (e) => {
    setSelectedDiscipline(e.target.value);
    fetchInstitutionEducation({
      startDate: formatDate(dateRange.from).replaceAll("/", "-"),
      endDate: formatDate(dateRange.to).replaceAll("/", "-"),
      knowledgeArea: selectedKnowledgeArea,
      discipline: e.target.value,
      courseTypeId: selectedCourseType,
      courseGradeId: selectedCourseGrade,
      localityId: selectedLocality,
      filtermodality: selectedModality,
    });
  };

  const handleCourseTypeChange = (e) => {
    setSelectedCourseType(e.target.value);
    fetchInstitutionEducation({
      startDate: formatDate(dateRange.from).replaceAll("/", "-"),
      endDate: formatDate(dateRange.to).replaceAll("/", "-"),
      knowledgeArea: selectedKnowledgeArea,
      discipline: selectedDiscipline,
      courseTypeId: e.target.value,
      courseGradeId: selectedCourseGrade,
      localityId: selectedLocality,
      filtermodality: selectedModality,
    });
  };

  const handleCourseGradeChange = (e) => {
    setSelectedCourseGrade(e.target.value);
    fetchInstitutionEducation({
      startDate: formatDate(dateRange.from).replaceAll("/", "-"),
      endDate: formatDate(dateRange.to).replaceAll("/", "-"),
      knowledgeArea: selectedKnowledgeArea,
      discipline: selectedDiscipline,
      courseTypeId: selectedCourseType,
      courseGradeId: e.target.value,
      localityId: selectedLocality,
      filtermodality: selectedModality,
    });
  };

  const handleLocalityChange = (e) => {
    setSelectedLocality(e.target.value);
    fetchInstitutionEducation({
      startDate: formatDate(dateRange.from).replaceAll("/", "-"),
      endDate: formatDate(dateRange.to).replaceAll("/", "-"),
      knowledgeArea: selectedKnowledgeArea,
      discipline: selectedDiscipline,
      courseTypeId: selectedCourseType,
      courseGradeId: selectedCourseGrade,
      localityId: e.target.value,
      filtermodality: selectedModality,
    });
  };

  const handleModalityChange = (e) => {
    setSelectedModality(e.target.value);
    fetchInstitutionEducation({
      startDate: formatDate(dateRange.from).replaceAll("/", "-"),
      endDate: formatDate(dateRange.to).replaceAll("/", "-"),
      knowledgeArea: selectedKnowledgeArea,
      discipline: selectedDiscipline,
      courseTypeId: selectedCourseType,
      courseGradeId: selectedCourseGrade,
      localityId: selectedLocality,
      filtermodality: e.target.value,
    });
  };

  const fetchKnowledgeAreas = async () => {
    if (knowledgeAreas.length > 0) return;
    try {
      setKnowledgeAreasLoading(true);
      const response = await insightsFilters({
        institutionId: institution.id,
        predictiveFilter: "knowledgearea"
      });

      setKnowledgeAreas(response.filterValues || []);
      setKnowledgeAreasFetched(true);
    } catch (error) {
      console.log("Erro ao buscar áreas de conhecimento", error);
    } finally {
      setKnowledgeAreasLoading(false);
    }
  };

  const fetchDisciplines = async () => {
    if (disciplines.length > 0) return;
    try {
      setDisciplinesLoading(true);
      const response = await insightsFilters({
        institutionId: institution.id,
        KnowledgeAreaFilter: selectedKnowledgeArea,
        predictiveFilter: "filterclass",
      });

      setDisciplines(response.filterValues || []);
      setdisciplinesFetched(true);
    } catch (error) {
      console.log("Erro ao buscar disciplinas", error);
    } finally {
      setDisciplinesLoading(false);
    }
  };

  const fetchCourseTypes = async () => {
    if (courseTypes.length > 0) return;
    try {
      setCourseTypesLoading(true);
      const response = await insightsFilters({
        institutionId: institution.id,
        KnowledgeAreaFilter: selectedKnowledgeArea,
        filterClass: selectedDiscipline,
        predictiveFilter: "filterdegree",
      });

      setCourseTypes(response.filterValues || []);
      setcourseTypesFetched(true);
    } catch (error) {
      console.log("Erro ao buscar tipos de curso", error);
    } finally {
      setCourseTypesLoading(false);
    }
  };

  const fetchCourseGrades = async () => {
    if (courseGrades.length > 0) return;
    try {
      setCourseGradesLoading(true);
      const response = await insightsFilters({
        institutionId: institution.id,
        predictiveFilter: "coursegrade",
      });

      setCourseGrades(response.filterValues || []);
      setcourseGradesFetched(true);
    } catch (error) {
      console.log("Erro ao buscar graus de curso", error);
    } finally {
      setCourseGradesLoading(false);
    }
  };

  const fetchLocalities = async () => {
    if (localities.length > 0) return;
    try {
      setLocalitiesLoading(true);
      const response = await insightsFilters({
        institutionId: institution.id,
        KnowledgeAreaFilter: selectedKnowledgeArea,
        filterClass: selectedDiscipline,
        predictiveFilter: "filterlocation",
      });

      setLocalities(response.filterValues || []);
      setlocalitiesFetched(true);
    } catch (error) {
      console.log("Erro ao buscar localidades", error);
    } finally {
      setLocalitiesLoading(false);
    }
  };

  const fetchModalities = async () => {
    if (modalities.length > 0) return;
    try {
      setModalitiesLoading(true);
      const response = await insightsFilters({
        institutionId: institution.id,
        predictiveFilter: "filtermodality",
      });

      setModalities(response.filterValues || []);
      setModalitiesFetched(true);
    } catch (error) {
      console.log("Erro ao buscar modalidades", error);
    } finally {
      setModalitiesLoading(false);
    }
  };

  const selectSuggestionRange = (suggestionRange) => {
    setSuggestionRange(suggestionRange);
    const currentYear = new Date().getFullYear();

    let selectedRange;
    switch (suggestionRange) {
      case "today":
        selectedRange = {
          from: new Date(),
          to: new Date()
        };
        break;
      case "last_7":
        selectedRange = {
          from: new Date(new Date().setDate(new Date().getDate() - 7)),
          to: new Date()
        };
        break;
      case "last_30":
        const last_30_now = new Date();
        selectedRange = {
          from: new Date(last_30_now.getFullYear(), last_30_now.getMonth(), 1),
          to: new Date(last_30_now.getFullYear(), last_30_now.getMonth() + 1, 0),
        };
        break;
      case "first_semester":
        selectedRange = {
          from: new Date(`${currentYear}-01-01T00:00:00`),
          to: new Date(`${currentYear}-06-30T23:59:59`)
        };
        break;

      case "second_semester":
        selectedRange = {
          from: new Date(`${currentYear}-07-01T00:00:00`),
          to: new Date(`${currentYear}-12-31T23:59:59`)
        };
        break;

      case "last_semester":
        const today_ls = new Date();
        const isSecondSemester = today_ls.getMonth() >= 6; // Julho = mês 6 (0-indexed)
        
        if (isSecondSemester) {
          // Estamos no segundo semestre, último semestre = primeiro semestre do ano atual
          selectedRange = {
            from: new Date(`${currentYear}-01-01T00:00:00`),
            to: new Date(`${currentYear}-06-30T23:59:59`)
          };
        } else {
          // Estamos no primeiro semestre, último semestre = segundo semestre do ano anterior
          const lastYear = currentYear - 1;
          selectedRange = {
            from: new Date(`${lastYear}-07-01T00:00:00`),
            to: new Date(`${lastYear}-12-31T23:59:59`)
          };
        }
        break;

      case "last_year":
        const now = new Date();
        const from = new Date(now.getFullYear() - 1, now.getMonth(), 1);
        const to = new Date(now.getFullYear(), now.getMonth(), 0);

        selectedRange = { from, to };
        break;
      case "current_year":
        selectedRange = {
          from: new Date(currentYear, 0, 1),
          to: new Date()
        };
        break;
      case "previous_year":
        const previousYear = currentYear - 1;
        selectedRange = {
          from: new Date(`${previousYear}-01-01T00:00:00`),
          to: new Date(`${previousYear}-12-31T23:59:59`)
        };
        break;

      case "last_5_years":
        selectedRange = {
          from: new Date(new Date().setFullYear(new Date().getFullYear() - 5)),
          to: new Date()
        };
        break;
      default:
        selectedRange = {
          from: new Date(new Date().setMonth(new Date().getMonth() - 3)),
          to: new Date(new Date().setMonth(new Date().getMonth() - 0))
        };
        break;
    }

    setDateRange(selectedRange);

    fetchInstitutionEducation({
      startDate: formatDate(selectedRange.from).replaceAll("/", "-"),
      endDate: formatDate(selectedRange.to).replaceAll("/", "-"),
      knowledgeArea: selectedKnowledgeArea,
      discipline: selectedDiscipline,
      courseTypeId: selectedCourseType,
      courseGradeId: selectedCourseGrade,
      localityId: selectedLocality,
      filtermodality: selectedModality
    });
  };

  const handleClearSelection = () => {
    setSuggestionRange("");
    setDateRange({
      from: new Date(),
      to: new Date()
    });
  };

  // Converter filtros atuais para o formato da API de filtros salvos
  const convertFiltersToApiFormat = () => {
    const hasActiveFilters = selectedCourseType || selectedKnowledgeArea || 
      selectedDiscipline || selectedLocality || selectedModality;

    if (!hasActiveFilters && !dateRange?.from && !dateRange?.to) {
      return null;
    }

    const filterData = {
      source: "Acadêmico",
      dateRange: {
        startDate: dateRange?.from ? formatDate(dateRange.from).replaceAll("/", "-") : null,
        endDate: dateRange?.to ? formatDate(dateRange.to).replaceAll("/", "-") : null
      },
      filters: {
        courseType: selectedCourseType || "",
        knowledgeArea: selectedKnowledgeArea || "",
        discipline: selectedDiscipline || "",
        locality: selectedLocality || "",
        modality: selectedModality || ""
      }
    };

    return filterData;
  };

  // Converter filtro salvo da API para o formato local
  const convertApiFilterToLocal = useCallback((savedFilter) => {
    try {
      // Parse do filterJson se for string
      let filterData;
      if (typeof savedFilter.filterJson === 'string') {
        filterData = JSON.parse(savedFilter.filterJson);
      } else {
        filterData = savedFilter.filterJson;
      }

      if (!filterData) return;

      console.log("Aplicando filtros do filtro salvo:", filterData);

      // Aplicar filtros de data
      if (filterData.dateRange) {
        const newDateRange = {};
        
        if (filterData.dateRange.startDate) {
          const [day, month, year] = filterData.dateRange.startDate.split('-');
          newDateRange.from = new Date(year, month - 1, day);
        }
        
        if (filterData.dateRange.endDate) {
          const [day, month, year] = filterData.dateRange.endDate.split('-');
          newDateRange.to = new Date(year, month - 1, day);
        }
        
        if (newDateRange.from || newDateRange.to) {
          setDateRange(prev => ({
            from: newDateRange.from || prev.from,
            to: newDateRange.to || prev.to
          }));
        }
      }

      // Aplicar filtros - SEMPRE atualizar, mesmo se vazio
      if (filterData.filters) {
        console.log("Atualizando campos de filtro:", filterData.filters);
        
        // Atualizar todos os campos, mesmo que vazios
        setSelectedCourseType(filterData.filters.courseType || "");
        setSelectedKnowledgeArea(filterData.filters.knowledgeArea || "");
        setSelectedDiscipline(filterData.filters.discipline || "");
        setSelectedLocality(filterData.filters.locality || "");
        setSelectedModality(filterData.filters.modality || "");
        
        console.log("Campos atualizados:", {
          courseType: filterData.filters.courseType || "",
          knowledgeArea: filterData.filters.knowledgeArea || "",
          discipline: filterData.filters.discipline || "",
          locality: filterData.filters.locality || "",
          modality: filterData.filters.modality || ""
        });
      }

    } catch (error) {
      console.error("Erro ao converter filtro salvo:", error);
      toast.error("Erro ao processar filtro salvo");
    }
  }, []);

  // Abrir modal de filtros salvos
  const handleOpenSavedFilters = () => {
    setShowSavedFiltersModal(true);
  };

  // Abrir modal de salvar filtro
  const handleOpenSaveFilter = () => {
    const filterData = convertFiltersToApiFormat();
    
    console.log("Filter data para salvar:", filterData);
    console.log("Estados atuais:", {
      selectedCourseType,
      selectedKnowledgeArea,
      selectedDiscipline,
      selectedLocality,
      selectedModality,
      dateRange
    });
    
    if (!filterData) {
      toast.warning("Adicione pelo menos um filtro ou selecione um período antes de salvar");
      return;
    }
    
    setShowSaveFilterModal(true);
  };

  // Atualizar URL com filterId
  const updateURLWithFilterId = (filterId) => {
    const params = new URLSearchParams();
    if (filterId) {
      params.set('filterId', filterId);
    }
    setSearchParams(params);
  };

  // Aplicar filtro salvo
  const handleApplySavedFilter = async (savedFilter) => {
    console.log("Filtro salvo recebido:", savedFilter);
    
    // Atualizar URL com o filterId
    updateURLWithFilterId(savedFilter.id);
    
    // Parse do filterJson
    const filterData = typeof savedFilter.filterJson === 'string' 
      ? JSON.parse(savedFilter.filterJson) 
      : savedFilter.filterJson;
    
    // Aplicar filtros localmente (atualizar os campos visuais)
    convertApiFilterToLocal(savedFilter);
    
    // Carregar opções das listas de acordo com os filtros aplicados
    if (filterData.filters?.knowledgeArea && knowledgeAreas.length === 0) {
      await fetchKnowledgeAreas();
    }
    if (filterData.filters?.discipline && disciplines.length === 0) {
      await fetchDisciplines();
    }
    if (filterData.filters?.courseType && courseTypes.length === 0) {
      await fetchCourseTypes();
    }
    if (filterData.filters?.locality && localities.length === 0) {
      await fetchLocalities();
    }
    if (filterData.filters?.modality && modalities.length === 0) {
      await fetchModalities();
    }
    
    // Buscar dados com os novos filtros aplicados
    setTimeout(() => {
      const startDate = filterData.dateRange?.startDate || formatDate(dateRange.from).replaceAll("/", "-");
      const endDate = filterData.dateRange?.endDate || formatDate(dateRange.to).replaceAll("/", "-");
      
      fetchInstitutionEducation({
        startDate,
        endDate,
        knowledgeArea: filterData.filters?.knowledgeArea || "",
        discipline: filterData.filters?.discipline || "",
        courseTypeId: filterData.filters?.courseType || "",
        localityId: filterData.filters?.locality || "",
        filtermodality: filterData.filters?.modality || ""
      });
      
      toast.success(`Filtro "${savedFilter.name}" aplicado com sucesso!`);
    }, 100);
  };

  // Limpar todos os filtros
  const handleClearFilters = () => {
    // Limpar todos os estados de filtros
    setSelectedKnowledgeArea("");
    setSelectedDiscipline("");
    setSelectedCourseType("");
    setSelectedCourseGrade("");
    setSelectedLocality("");
    setSelectedModality("");
    
    // Limpar as listas de opções dependentes
    setDisciplines([]);
    setCourseGrades([]);
    setLocalities([]);
    
    // Resetar flags de fetch
    setdisciplinesFetched(false);
    setcourseGradesFetched(false);
    setlocalitiesFetched(false);
    
    // Limpar URL
    setSearchParams(new URLSearchParams());
    
    // Limpar filtros do localStorage
    clearSharedFilters();
    
    // Buscar dados sem filtros
    fetchInstitutionEducation({
      startDate: formatDate(dateRange.from).replaceAll("/", "-"),
      endDate: formatDate(dateRange.to).replaceAll("/", "-"),
      knowledgeArea: "",
      discipline: "",
      courseTypeId: "",
      courseGradeId: "",
      localityId: "",
      filtermodality: ""
    });
    
    toast.success("Filtros limpos com sucesso!");
  };

  // Todos os cards apontam para os dados consolidados no mesmo período do filtro.
  const consolidatedLink = `/app/dados-consolidados-academicos?startDate=${formatDate(dateRange?.from).replaceAll("/", "-")}&endDate=${formatDate(dateRange?.to).replaceAll("/", "-")}`;

  return (
    <div>
      <HeaderTitle title="Acadêmicos" icon={AcademicIcon}>
      </HeaderTitle>

      <div className={styles.filterWrapper}>
        <div className={styles.filterContainer}>
          <FilterSelect
            icon={CourseIcon}
            label="Tipo de Curso"
            value={selectedCourseType}
            loading={courseTypesLoading}
            options={courseTypes}
            onFocus={fetchCourseTypes}
            hasFetched={courseTypesFetched}
            onChange={handleCourseTypeChange}
          />
          <FilterSelect
            icon={BookIcon}
            label="Área de Conhecimento"
            value={selectedKnowledgeArea}
            loading={knowledgeAreasLoading}
            options={knowledgeAreas}
            onFocus={fetchKnowledgeAreas}
            hasFetched={knowledgeAreasFetched}
            onChange={handleKnowledgeAreaChange}
          />
          <FilterSelect
            icon={DiscIcon}
            label="Curso"
            value={selectedDiscipline}
            loading={disciplinesLoading}
            options={disciplines}
            onFocus={fetchDisciplines}
            hasFetched={disciplinesFetched}
            onChange={handleDisciplineChange}
          />
          <FilterSelect
            icon={LocaleIcon}
            label="Localidade"
            value={selectedLocality}
            loading={localitiesLoading}
            options={localities}
            onFocus={fetchLocalities}
            hasFetched={localitiesFetched}
            onChange={handleLocalityChange}
          />
          <FilterSelect
            icon={ClassesIcon}
            label="Modalidade"
            value={selectedModality}
            loading={modalitiesLoading}
            options={modalities}
            onFocus={fetchModalities}
            hasFetched={modalitiesFetched}
            onChange={handleModalityChange}
          />
        </div>

        <div className={styles.headerTitleActions}>
          <Button
            icon={BarsFilterIcon}
            text="Filtros Salvos"
            size="normal"
            variation="outline"
            onClick={handleOpenSavedFilters}
          />
          
          <Button
            icon={BarsFilterIcon}
            text="Salvar Filtro"
            size="normal"
            variation="primary"
            onClick={handleOpenSaveFilter}
          />

          <Button
            icon={BarsFilterIcon}
            text="Limpar Filtros"
            size="normal"
            variation="secondary"
            onClick={handleClearFilters}
          />

          <div className={styles.headerTitleActionsCalendar}>
            <Button
              icon={CalendarIcon}
              text={dateRangeString}
              size="normal"
              variation="outline"
              onClick={() => setIsCalendarOpen(!isCalendarOpen)}
            />

            {isCalendarOpen && (
              <div 
                ref={calendarRef} 
                className={styles.calenderContent}
              >
                <div className={styles.suggestions}>
                  <ul>
                    <li
                      onClick={() => !loading && selectSuggestionRange("today")}
                      className={clsx(styles.suggestionsItem, {
                        [styles.active]: suggestionRange === "today"
                      })}
                      style={{ opacity: loading ? 0.6 : 1, cursor: loading ? 'not-allowed' : 'pointer' }}
                    >
                      Hoje
                    </li>
                    <li
                      onClick={() => !loading && selectSuggestionRange("last_7")}
                      className={clsx(styles.suggestionsItem, {
                        [styles.active]: suggestionRange === "last_7"
                      })}
                      style={{ opacity: loading ? 0.6 : 1, cursor: loading ? 'not-allowed' : 'pointer' }}
                    >
                      Últimos 7 dias
                    </li>
                    <li
                      onClick={() => !loading && selectSuggestionRange("last_30")}
                      className={clsx(styles.suggestionsItem, {
                        [styles.active]: suggestionRange === "last_30"
                      })}
                      style={{ opacity: loading ? 0.6 : 1, cursor: loading ? 'not-allowed' : 'pointer' }}
                    >
                      Último mês
                    </li>
                    <li
                      onClick={() => !loading && selectSuggestionRange("first_semester")}
                      className={clsx(styles.suggestionsItem, {
                        [styles.active]: suggestionRange === "first_semester"
                      })}
                      style={{ opacity: loading ? 0.6 : 1, cursor: loading ? 'not-allowed' : 'pointer' }}
                    >
                      Primeiro Semestre
                    </li>
                    <li
                      onClick={() => !loading && selectSuggestionRange("second_semester")}
                      className={clsx(styles.suggestionsItem, {
                        [styles.active]: suggestionRange === "second_semester"
                      })}
                      style={{ opacity: loading ? 0.6 : 1, cursor: loading ? 'not-allowed' : 'pointer' }}
                    >
                      Segundo Semestre
                    </li>
                    <li
                      onClick={() => !loading && selectSuggestionRange("last_semester")}
                      className={clsx(styles.suggestionsItem, {
                        [styles.active]: suggestionRange === "last_semester"
                      })}
                      style={{ opacity: loading ? 0.6 : 1, cursor: loading ? 'not-allowed' : 'pointer' }}
                    >
                      Último Semestre
                    </li>
                    <li
                      onClick={() => !loading && selectSuggestionRange("last_year")}
                      className={clsx(styles.suggestionsItem, {
                        [styles.active]: suggestionRange === "last_year"
                      })}
                      style={{ opacity: loading ? 0.6 : 1, cursor: loading ? 'not-allowed' : 'pointer' }}
                    >
                      Últimos 12 meses
                    </li>
                    <li
                      onClick={() => !loading && selectSuggestionRange("current_year")}
                      className={clsx(styles.suggestionsItem, {
                        [styles.active]: suggestionRange === "current_year"
                      })}
                      style={{ opacity: loading ? 0.6 : 1, cursor: loading ? 'not-allowed' : 'pointer' }}
                    >
                      Ano Atual
                    </li>
                    <li
                      onClick={() => !loading && selectSuggestionRange("previous_year")}
                      className={clsx(styles.suggestionsItem, {
                        [styles.active]: suggestionRange === "previous_year"
                      })}
                      style={{ opacity: loading ? 0.6 : 1, cursor: loading ? 'not-allowed' : 'pointer' }}
                    >
                      Ano Anterior
                    </li>
                    <li
                      onClick={() => !loading && selectSuggestionRange("last_5_years")}
                      className={clsx(styles.suggestionsItem, {
                        [styles.active]: suggestionRange === "last_5_years"
                      })}
                      style={{ opacity: loading ? 0.6 : 1, cursor: loading ? 'not-allowed' : 'pointer' }}
                    >
                      Últimos 5 Anos
                    </li>
                    <li
                      onClick={() => !loading && selectSuggestionRange("manual")}
                      className={clsx(styles.suggestionsItem, {
                        [styles.active]: suggestionRange === "manual"
                      })}
                      style={{ opacity: loading ? 0.6 : 1, cursor: loading ? 'not-allowed' : 'pointer' }}
                    >
                      Personalizado
                    </li>
                  </ul>
                  <div>
                    <div
                      onClick={() => !loading && handleClearSelection()}
                      className={clsx(styles.suggestionsItem, styles.active)}
                      style={{ opacity: loading ? 0.6 : 1, cursor: loading ? 'not-allowed' : 'pointer' }}
                    >
                      Limpar seleção
                    </div>

                    <div
                      onClick={() => !loading && selectManualRange()}
                      className={clsx(
                        styles.suggestionsItem,
                        styles.active,
                        styles["btn-search-data"]
                      )}
                      style={{
                        opacity: loading ? 0.8 : 1,
                        cursor: loading ? 'not-allowed' : 'pointer'
                      }}
                    >
                      {loading ? (
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                          <img
                            src={loadingGif}
                            alt="Carregando..."
                            style={{ width: "16px", height: "16px" }}
                          />
                          <span>Carregando...</span>
                        </div>
                      ) : (
                        <>
                          <img src={MagnifyingGlassIcon} alt="magnifying-glass" />
                          Buscar dados
                        </>
                      )}
                    </div>
                  </div>
                </div>

                <div className={styles.dateRangeGroup}>
                  <div className={styles.datePickerWrapper}>
                    <label>Data de Início</label>
                    <DayPicker
                      mode="single"
                      selected={dateRange?.from}
                      defaultMonth={dateRange?.from}
                      onSelect={(from) => setDateRange((prev) => ({ ...prev, from }))}
                      locale={ptBR}
                      captionLayout="dropdown"
                    />
                  </div>

                  <div className={styles.datePickerWrapper}>
                    <label>Data de Fim</label>
                    <DayPicker
                      mode="single"
                      selected={dateRange?.to}
                      defaultMonth={dateRange?.to}
                      onSelect={(to) => setDateRange((prev) => ({ ...prev, to }))}
                      locale={ptBR}
                      captionLayout="dropdown"
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className={styles.financeContent}>
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "300px"
            }}
          >
            <img
              src={loadingGif}
              alt="Carregando..."
              style={{ width: "60px", height: "60px" }}
            />
          </div>
        ) : education === null ? (
          <ZeroData>
            <div>
              <h3>Sem dados para o período</h3>
              <p>
                Não encontramos dados para o período filtrado. Altere as datas ou importe dados para esse período{" "}
                <span 
                  onClick={() => navigate("/app/importar-dados")} 
                  style={{ color: "#1976d2", cursor: "pointer", textDecoration: "underline" }}
                >
                  na página de importação de dados
                </span>.
              </p>
            </div>
          </ZeroData>
        ) : education ? (
          <>
            {/* 9 indicadores em uma grade unica de 3 colunas: 3 linhas cheias, sem buraco no fim */}
            <div className={styles.grid_2}>
              <FinanceCard
                title="Total de Alunos Ativos"
                value={education.activeStudents}
                icon={UsersIcon}
                explanation={"Quantidade de estudantes diferentes com status Ativo no cadastro da instituição."}
                dataLink={consolidatedLink}
                code="E-A14"
              />

              <FinanceCard
                title="Alunos Inativos"
                value={education.inactiveStudents}
                icon={UserDeleteIcon}
                explanation={"Estudantes com status Inativo no cadastro da instituição."}
                dataLink={consolidatedLink}
                code="E-A15"
              />
              <FinanceCard
                title="Taxa de Frequencia de Alunos"
                value={addPorcentage(education.avgStudentFrequency)}
                icon={ChartMixedUpCircleDollarIcon}
                explanation={"Média da presença dos estudantes nas aulas, indicando seu nível de assiduidade e engajamento."}
                dataLink={consolidatedLink}
                code="E-A3"
              />

              <FinanceCard
                title="Taxa de Aprovação dos Curso"
                value={addPorcentage(education.courseApprovalRate)}
                icon={DocumentCheckedFilled}
                explanation={"Quantidade de estudantes que alcançaram a nota mínima exigida e foram aprovados nas disciplinas."}
                dataLink={consolidatedLink}
                code="E-A7"
              />

              <FinanceCard
                title="Nota média dos professores"
                value={Number(education.avgTeacherPerformance ?? 0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                icon={ChartUserCheckIcon}
                explanation={"Média das notas finais atribuídas aos docentes nas disciplinas."}
                dataLink={consolidatedLink}
                code="E-A6"
              />
              <FinanceCard
                title="Taxa de Conclusão dos Cursos"
                value={addPorcentage(education.courseCompletionRate)}
                icon={RegistrationConcluseIcon}
                explanation={"Percentual de estudantes que completaram todas as etapas de ingresso, da matrícula ao aceite, em relação ao total de matriculados."}
                dataLink={consolidatedLink}
                code="E-A2"
              />

              <FinanceCard
                title="Média de Cancelamento dos Cursos"
                value={addPorcentage(education.cancellationRate)}
                icon={ChartMixedRightCircleDollar}
                explanation={"Percentual de estudantes que tiveram a matrícula cancelada em relação ao total de matriculados."}
                code="E-A4"
              />

              <FinanceCard
                title="Tempo médio de Matrícula em dias"
                value={education.avgCompletionTimeInDays}
                icon={ChartMixedRightCircleDollar}
                explanation={"Média de dias que os alunos levam do pré-cadastro até a matrícula efetiva."}
                dataLink={consolidatedLink}
                code="E-A8"
              />
              <FinanceCard
                title="Carga Horária Média"
                value={`${pluralize(education.avgCourseLoad, "hora", "horas")}`}
                icon={ChartUserSearchIcon}
                explanation={"Média da carga horária das disciplinas, em horas, refletindo o volume de aulas ministradas aos estudantes."}
                dataLink={consolidatedLink}
                code="E-A5"
              />
            </div>

            <StudentsTreemap
              title="Alunos por Status"
              code="E-A16"
              info="Distribuição dos alunos matriculados por status de matrícula. Sem status = aluno que aparece apenas na base acadêmica, sem cadastro correspondente em Alunos."
              items={Object.entries(
                _.countBy(education.studentData || [], (s) => s.studentStatus || "Sem status")
              ).map(([statusLabel, total]) => ({ statusLabel, total }))}
              labelKey="statusLabel"
              valueKey="total"
              filterField="StudentStatus"
              onSelect={(sel) => {
                setStudentStatus(STATUS_FILTER[sel.display] || "todos");
                if (sel.display === "Sem status") {
                  setShowNoStatusModal(true);
                }
              }}
            />

            <StudentsTable
              studentData={education.studentData}
              status={studentStatus}
              onStatusChange={setStudentStatus}
            />

            <EducationDebtsPeriod
              agePeriod={ageGroup}
              code="E-A10"
            />

            {/*
            HERE GO THE NEW COMPONENTS
          */}
            <div className={styles.grid_2}>
              <StudentsTreemap
                title="Alunos por Professor"
                code="E-A11"
                info="Quantidade de alunos distintos atendidos por cada docente (Id do docente). Um aluno pode ser contado em mais de um professor, então a soma supera o total de alunos."
                items={education.teacherData}
                labelKey="teacherName"
                valueKey="teacherTotalStudents"
                filterField="TeacherId"
                onSelect={setDrill}
              />

              <StudentsTreemap
                title="Alunos por Disciplina"
                code="E-A12"
                info="Quantidade de alunos distintos matriculados em cada disciplina. Um aluno pode cursar várias disciplinas, então a soma supera o total de alunos."
                items={education.disciplineData}
                labelKey="disciplineTitle"
                valueKey="totalStudents"
                filterField="DisciplineTitle"
                onSelect={setDrill}
              />

              <StudentsTreemap
                title="Alunos por Curso"
                code="E-A13"
                info="Quantidade de alunos distintos matriculados em cada curso. Um aluno pode estar em mais de um curso, então a soma supera o total de alunos."
                items={education.courseData}
                labelKey="courseName"
                valueKey="totalStudents"
                filterField="CourseName"
                onSelect={setDrill}
              />
            </div>

            {drill && (
              <TreemapDrillTable
                institutionId={institution?.id}
                filter={drill}
                onClose={() => setDrill(null)}
              />
            )}

            <TeacherTable teacherData={education.teacherData} />
            {/* </div> */}

            {/* {finance.delinquency && (
              <div className={styles.grid_5}>
                <FinanceDebts delinquency={finance.delinquency} />

                <FinanceDebtsPeriod
                  delinquencyPeriod={finance.delinquencyPeriod}
                />
              </div>
            )}

            <div className={styles.grid_1}>
              <FinanceAgreements agreements={finance.agreements} />
            </div> */}
          </>
        ) : (
          <ZeroData>
            <div>
              <h3>Sem dados para o período</h3>
              <p>
                Não encontramos dados para o período filtrado. Altere as datas ou importe dados para esse período{" "}
                <span 
                  onClick={() => navigate("/app/importar-dados")} 
                  style={{ color: "#1976d2", cursor: "pointer", textDecoration: "underline" }}
                >
                  na página de importação de dados
                </span>.
              </p>
            </div>
          </ZeroData>
        )}
      </div>

      {/* Modais */}
      {showSavedFiltersModal && (
        <SavedFiltersModal
          onClose={() => setShowSavedFiltersModal(false)}
          onApplyFilter={handleApplySavedFilter}
          filterSource="Acadêmico"
          onCreateFilter={handleOpenSaveFilter}
        />
      )}
      
      {showSaveFilterModal && (
        <SaveFilterModal
          onClose={() => setShowSaveFilterModal(false)}
          onFilterSaved={() => {
            toast.success("Filtro salvo com sucesso!");
            setShowSaveFilterModal(false);
          }}
          filterData={convertFiltersToApiFormat()}
        />
      )}

      {showNoStatusModal && (
        <div className={modalStyles.modalBackdrop} onClick={() => setShowNoStatusModal(false)}>
          <div className={modalStyles.modalContent} onClick={(e) => e.stopPropagation()}>
            <div className={modalStyles.modalHeader}>
              <h3>Alunos sem status</h3>
              <button className={modalStyles.closeButton} onClick={() => setShowNoStatusModal(false)}>
                ×
              </button>
            </div>

            <p>
              Esses alunos aparecem na base acadêmica, mas não têm cadastro correspondente em Alunos —
              por isso ficam sem status. Para preenchê-lo, importe um arquivo de Alunos contendo as
              colunas <strong>ID_Aluno</strong> e <strong>Status_Aluno</strong>: os alunos com o mesmo
              ID_Aluno são atualizados com o status informado.
            </p>

            <div className={modalStyles.modalActions}>
              <Button
                text="Fechar"
                variation="secondary"
                size="medium"
                onClick={() => setShowNoStatusModal(false)}
                styling={{ padding: "8px 20px", fontSize: "13px" }}
              />
              <Button
                text="Importar alunos"
                variation="primary"
                size="medium"
                onClick={() => navigate("/app/importar-dados")}
                styling={{ padding: "8px 20px", fontSize: "13px" }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Education;
